export default __webpack_public_path__ + "static/media/group-579@2x.c33bb081.png";